import axios from "axios";

async function presignedUrl(key, folder) {
  try {
    const response = await axios.post(
      "https://booking.skin.drdropin.no/api/getImage",
      {
        uuid: key,
        folder: folder,
      }
    );

    return response.data.url;
  } catch (err) {
    console.log("err", err);
  }
}

export default presignedUrl;
